<template>
  <div class="main-page-container">
    <div class="content-container">
      <component :is="headerComponent"></component>
      <component :is="columnComponent"></component>
      <router-view></router-view>
      <component :is="footerComponent"></component>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBox from '@/components/HeaderBox'
import HeaderBoxMobile from '@/components/HeaderBox/Mobile'
import ColumnBox from '@/components/ColumnBox'
import ColumnBoxMobile from '@/components/ColumnBox/Mobile'
import FooterBox from '@/components/FooterBox'
import FooterBoxMobile from '@/components/FooterBox/Mobile'

export default {
  name: 'AppIndex',
  components: { HeaderBox, HeaderBoxMobile, ColumnBox, ColumnBoxMobile, FooterBox, FooterBoxMobile },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([ 'isPC' ]),
    headerComponent () {
      return this.isPC ? 'header-box' : 'header-box-mobile'
    },
    columnComponent () {
      return this.isPC ? 'column-box' : 'column-box-mobile'
    },
    footerComponent () {
      return this.isPC ? 'footer-box' : 'footer-box-mobile'
    }
  }
}
</script>

<style lang="scss" scoped>
.main-page-container {
  display: flex;
  justify-content: center;
  .content-container {
    width: 13.66rem;
    margin: 0 auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue